import { render, staticRenderFns } from "./ConstructingBar.vue?vue&type=template&id=f16c1506&"
import script from "./ConstructingBar.vue?vue&type=script&lang=ts&"
export * from "./ConstructingBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports